import { render, staticRenderFns } from "./layoutTags.vue?vue&type=template&id=270679d6&scoped=true&"
import script from "./layoutTags.vue?vue&type=script&lang=js&"
export * from "./layoutTags.vue?vue&type=script&lang=js&"
import style0 from "./layoutTags.vue?vue&type=style&index=0&id=270679d6&rel=stylesheet%2Fscss&lang=scss&scoped=true&"
import style1 from "./layoutTags.vue?vue&type=style&index=1&rel=stylesheet%2Fscss&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270679d6",
  null
  
)

export default component.exports